var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysEmailWithBorder = function SvgSysEmailWithBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8c99af",
    d: "M11.999 24A12 12 0 0 1 3.514 3.514a12 12 0 0 1 16.971 16.972A11.923 11.923 0 0 1 11.999 24Zm-4.4-16.8a1.2 1.2 0 0 0-1.194 1.2v7.2a1.2 1.2 0 0 0 1.2 1.2h9.6a1.2 1.2 0 0 0 1.2-1.2V8.4a1.2 1.2 0 0 0-1.2-1.2Zm4.8 5.292a.593.593 0 0 1-.319-.091L7.839 9.75a.509.509 0 0 1 .269-.941.507.507 0 0 1 .27.078l4.021 2.513 4.02-2.514a.515.515 0 0 1 .271-.079.51.51 0 0 1 .268.942l-4.24 2.651a.6.6 0 0 1-.319.093Z",
    "data-name": "Subtra\\xE7\\xE3o 30"
  })));
};
export default SvgSysEmailWithBorder;